import * as PropTypes from "prop-types";
import {Component} from "react";
import * as React from "react";
import classNames from "classnames";
import {Col, Row} from "reactstrap";
import "./TimeLine.scss";

/**
 * Time line položka.
 */
export default class TimeLine extends Component {

    static propTypes = {
        color: PropTypes.string.isRequired
    };

    render() {
        const {className, label, color, ...others} = this.props;

        const cls = classNames(
            "time-line"
        );

        const clsLabel = classNames(
            "label",
            "bg-" + color
        );

        return <Row className={cls}>
            <Col className={label ? "item col-auto" : "item-small col-auto"} >
                {label && <div className={clsLabel} title={label}>{label}</div>}
                {label && <div className={classNames("arrow", "arrow-"+color)}/>}
                <div className={"pit"}/>
            </Col>
            <Col className={"timeline-content" + (className ? " " + className : "")} {...others}>{this.props.children}</Col>
        </Row>
    }
}
